import { Dispatch } from 'redux'
import { setPageNotFound } from './pageNotFoundActions'
import { setSkeleton } from './skeletonActions'
import { setError } from './errorCodeActions'
import { ErrorCodes, ErrorActions, LocalStorageItem } from '@constants/index'
import { RootState } from 'store'
import { Action } from '@reducers/pageReducer'
import { VelvetSDK } from 'sdk'

export const FETCH_PAGE_REQUEST = 'FETCH_PAGE_REQUEST' as const
export const FETCH_PAGE_SUCCESS = 'FETCH_PAGE_SUCCESS' as const
export const FETCH_PAGE_FAILURE = 'FETCH_PAGE_FAILURE' as const
export const RESET_PAGE = 'RESET_PAGE' as const

export const fetchPageRequest = () => ({ type: FETCH_PAGE_REQUEST })
export const fetchPageSuccess = (page: any) => ({
  type: FETCH_PAGE_SUCCESS,
  payload: page,
})

export const fetchPageFailure = (error: string) => ({
  type: FETCH_PAGE_FAILURE,
  payload: error,
})

export const resetPage = () => ({ type: RESET_PAGE })

export const fetchPage = (pageSlug: string, subscriptionPlan: string, language?: string) => {
  const slug = pageSlug?.includes('/') ? pageSlug?.split('/')[0] : pageSlug
  const activeProfile = JSON.parse(localStorage.getItem(LocalStorageItem.ACTIVE_PROFILE) as string)

  return async (dispatch: Dispatch<Action>, getState: () => RootState) => {
    dispatch(setPageNotFound(false))
    dispatch(fetchPageRequest())

    if (process.env.REACT_APP_BASE_URL) {
      const userCountry = getState().userCountry.data.countryCode
      const feedData = await VelvetSDK.CMS.service().fetchPage(
        slug,
        subscriptionPlan,
        activeProfile.identifier,
        language,
        userCountry,
      )
      const page = feedData
      const errorFetchAction = getState().errorCode?.fetchAction
      if (page && !page.error) {
        dispatch(fetchPageSuccess(page))
        dispatch(setSkeleton(false))
        setPageNotFound(false)
        errorFetchAction === ErrorActions.FEED &&
          dispatch(setError({ errorCode: '', showErrorModal: false, feedPageSlug: '' }))
      } else if (page && page.error) {
        const errorUpdate = {
          showErrorModal: true,
          errorCode: ErrorCodes.FETCH_FEED,
          HTTPcode: page.error.status ?? 0,
          fetchAction: ErrorActions.FEED,
          feedPageSlug: slug,
          feedSubscriptionPlan: subscriptionPlan,
        }

        dispatch(setSkeleton(false))
        page?.error.status ? dispatch(setError(errorUpdate)) : dispatch(setPageNotFound(true))
      } else if (page === undefined) {
        dispatch(setSkeleton(false))
        dispatch(setPageNotFound(true))
      }
    }
  }
}
